import MoneyBackGuarantee from '../src/MoneyBackGuarantee/index.tsx';
export default MoneyBackGuarantee;
